import React, { useState } from 'react';
import api from '../utils/axios';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';
import { Download, FileSpreadsheet, Loader2 } from 'lucide-react';

export const ExcelExportButton = ({ type, filters = {}, label, variant = 'outline', size = 'sm' }) => {
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      Object.entries(filters).forEach(([k, v]) => { if (v) params.append(k, v); });
      const url = `/exports/${type}/excel${params.toString() ? '?' + params.toString() : ''}`;

      const res = await api.get(url, { responseType: 'blob' });

      const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = downloadUrl;
      const disposition = res.headers['content-disposition'];
      const filename = disposition ? disposition.split('filename=')[1] : `${type}_export.xlsx`;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(downloadUrl);
      toast.success(`Exportación de ${label || type} descargada`);
    } catch (err) {
      console.error('Export error', err);
      toast.error('Error al exportar');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleExport}
      disabled={loading}
      data-testid={`excel-export-${type}`}
      className="gap-1.5"
    >
      {loading ? (
        <Loader2 size={14} className="animate-spin" />
      ) : (
        <FileSpreadsheet size={14} />
      )}
      <span className="hidden sm:inline">{label || 'Exportar Excel'}</span>
      <span className="sm:hidden">Excel</span>
    </Button>
  );
};

export default ExcelExportButton;
